import { CreateSessionDocument } from '@graphql/generated/graphql';

import { useInitializeSession } from '@services/AuthService/useInitializeSession';

import { useMutation } from '@apollo/client';

export const useLogin = () => {
    const [createCreateSession, { error, reset }] = useMutation(
        CreateSessionDocument,
        {
            context: {
                notifyOnError: true,
            },
            notifyOnNetworkStatusChange: true,
            onError: () => {},
        },
    );
    const { initializeSession } = useInitializeSession(
        createCreateSession,
        true,
    );

    return {
        cancelLogin: reset,
        handleLogin: initializeSession,
        loginError: error,
    };
};
